import {
  Component,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { PendingOrdersService } from 'src/app/services/pending-orders.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-previous-order',
  templateUrl: './previous-order.component.html',
  styleUrls: ['./previous-order.component.scss'],
})
export class PreviousOrderComponent implements OnInit, OnDestroy {
  @ViewChild('infiteScroll', { static: true }) infiteScroll: InfiniteScroll;
  @Output() openInscriptionEmitter = new EventEmitter();
  public testImg = environment.defaultImg;
  public orders: any[] = [];
  public loaded = false;
  public noSubscriptionsMsg = '';
  private _totalPages = undefined;
  private reloadObs: Subscription = new Subscription();

  constructor(private pendingOrderSv: PendingOrdersService) {}

  async ngOnInit() {
    await this.getSubscriptions();
    this.loaded = true;
    const obs = this.pendingOrderSv.reloadList.subscribe(async () => {
      this.pendingOrderSv.page = 1;
      this.orders = [];
      await this.getSubscriptions();
    });
    this.reloadObs.add(obs);
  }

  ngOnDestroy(): void {
    this.reloadObs.unsubscribe();
  }

  async getSubscriptions() {
    try {
      const data = await this.pendingOrderSv.getOrders();
      if (!this._totalPages) {
        this._totalPages = data.meta.last_page;
      }
      // this._totalPages = data.meta.last_page;
      this.orders.push(...data.data);
    } catch (err) {
      console.error(err);
    }
  }

  async openInscription(order) {
    // inscription.subscription.status = inscription.status;
    // inscription.subscription.renovation = inscription.renovation;
    // inscription.subscription.inscriptionId = inscription.id;
    this.openInscriptionEmitter.emit(order);
  }

  async loadData(ev: InfiniteScroll) {
    ev.disconnect();
    if (this.pendingOrderSv.page > this._totalPages) {
      ev.complete();
      ev.disconnect();
      return true;
    } else {
      this.pendingOrderSv.page++;
    }
    await this.getSubscriptions();
    ev.observe();
  }
}
